export default __webpack_public_path__ + "instagram-start.e9fb8fdb08025af137840f39b6127981.png";